var exports = {
  "K": "HeroSection__R4eqX9",
  "y": "HeroSection__Spacer__JegAKV",
};

module.exports = exports;
